// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__13pww","insightsList":"newBusinessInsightsMenu_insightsList__363lN","active":"newBusinessInsightsMenu_active__2gxBB"};